export default __webpack_public_path__ + "static/media/gp-brands-desktop.0e7244e0.svg";